import { Box, Grid, Typography, styled } from "@mui/material";
import { useRouter } from "next/router";
import React, { useContext } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "swiper/css";
import "swiper/css/pagination";
import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import { sendAnalytics } from "../../utils/analyticsCommon";
import { MemoizedButton } from "../button";

const CustomVehicleModelCards = styled(Box)(({ theme }) => ({
  magin: "40px",
  paddingTop: "100px",
  maxWidth: "400px",

  //   background: "#FFF9FA",

  ".grid-layout": {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  ".vehicle-box": {
    margin: "10px",
    // padding: "10px",
    border: "1px solid #D9D9D9",
    borderRadius: "5px",
  },

  ".vehicle-image-box": {
    // width: "100%",
    minHeight: "110px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 0px 5px",
  },
  ".vehicle-image": {
    //height: "80px",
    width: "100%",
  },
  ".book-test-drive-button": {
    borderRadius: "8px",
    boxShadow: "none",
    border: "none",
    paddingLeft: "10px",
    paddingRight: "10px",
  },

  ".name-text": {
    fontSize: "14px",
    padding: "5px 10px 0px",
    fontWeight: 700,
  },
  ".desc-text": {
    fontSize: "12px",
    padding: "5px 10px 20px",
  },
  //   ".form-box": {
  //     width: "100%",
  //   },
  ".check-vehicle-button": {
    background: primary?.main,
    marginTop: "10px",
    fontSize: "16px !important",
    borderRadius: "5px !important",
    padding: "10px",
    width: "100%",
    boxShadow: "none !important",
    border: "none !important",
  },
  ".vehicle-image": {
    zIndex: "1",
    position: "relative",
    top: "50%",
    left: "50%",

    transform: "translate(-50%, -50%)",
    "-ms-transform": "translate(-50%, -50%)",
    maxWidth: "260px",
  },

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    paddingTop: "40px",

    ".check-vehicle-button": {
      fontSize: "14px !important",
    },

    ".vehicle-image": {
      zIndex: "1",
      position: "relative",
      top: "50%",
      left: "50%",

      transform: "translate(-50%, -50%)",
      "-ms-transform": "translate(-50%, -50%)",
      maxWidth: "200px",
    },
    // padding: "20px",
  },
}));

const VehicleModelCards = ({ data }) => {
  //   cons;
  //const navigate = useRouter();

  const { showLoanPopup } = useContext(Context);
  const navigate = useRouter();
  const brandName = data?.brand;

  const name = brandName?.charAt(0)?.toUpperCase() + brandName?.slice(1);

  return (
    <CustomVehicleModelCards>
      <Box style={{ background: primary?.white, borderRadius: "8px" }}>
        <Box>
          <Box style={{ height: "60px" }}>
            <LazyLoadImage
              src={data?.homeImage}
              className="vehicle-image"
              //   style={{
              //     zIndex: "1",
              //     position: "relative",
              //     top: "50%",
              //     left: "50%",

              //     transform: "translate(-50%, -50%)",
              //     "-ms-transform": "translate(-50%, -50%)",
              //     maxWidth: "200px",
              //   }}
              loading="lazy"
              alt={`${data?.brand} ${data?.vehicle_name}`}
            />
          </Box>

          <Box sx={{ padding: { xs: "10px" } }}>
            <Box display={"block"} style={{ paddingTop: "30px" }}>
              <Grid container style={{ padding: "20px 10px 0px 10px" }}>
                <Grid
                  item
                  style={{ width: "100%" }}
                  xs={8}
                  key={data?.vehicle_path_id}
                >
                  <Box style={{ width: "100%" }}>
                    <LazyLoadImage
                      src={data?.vehicle_logo}
                      style={{
                        height: "48px",

                        width: "80px",
                        margin: "auto",
                        objectFit: "contain",
                        float: "left",
                      }}
                      alt={data?.vehicle_path_id}
                    />
                  </Box>{" "}
                </Grid>
                <Grid
                  item
                  style={{ width: "100%", alignItems: "center" }}
                  xs={4}
                >
                  {/* <Box style={{border:"none", borderRadius:"8px", background:primary?.lightYellowBg}}>Good Choice!!</Box> */}{" "}
                  <LazyLoadImage
                    src={data?.deal}
                    style={{ maxHeight: "20px", justifyContent: "flex-start" }}
                    alt={data?.vehicle_path_id}
                  />
                </Grid>
              </Grid>

              <Typography className="name-text">
                TOP RANGE :{" "}
                <span style={{ fontWeight: 700 }}>{data?.range}</span>
              </Typography>

              <Typography className="name-text">
                Starting EMI :{" "}
                <span style={{ fontWeight: 700, color: primary?.main }}>
                  ₹{data?.emiPrice}
                </span>
                / Month
              </Typography>

              {/* <iframe width="100%" height="180" src="https://www.youtube.com/embed/QWabjSPAW7I" title="Managing restaurant business like pro with EV | Electric cargo vehicle | Marathi | Turno" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
            </Box>
          </Box>
        </Box>
      </Box>

      <MemoizedButton
        className="check-vehicle-button"
        content={`Get On Road Price`}
        handleClick={() => {
          let payload = {
            vehicle_id: data?.id,
            vehicle_name: data?.name,
          };
          sendAnalytics("v2_latest_model_check_vehicle", payload, "en");
          const loanPayload = {
            brand: data?.brand,
            formTrigger: "v2_view_vehicle_latest_model",
            vehicle_id: data?.vehicle_path_id,
          };
          if (localStorage?.getItem("phoneInfo") === null) {
            showLoanPopup(loanPayload);
          } else {
            navigate.push(
              `/electric-commercial-vehicles/${data?.brand}/${data?.vehicle_path_id}`
            );
          }
          //navigate.push(`/vehicles/${data?.brand}`);
        }}
      />
    </CustomVehicleModelCards>
  );
};

export default VehicleModelCards;
